const CRON_FIELD_RANGES: [number, number][] = [
  [0, 59],  // minute
  [0, 23],  // hour
  [1, 31],  // day of month
  [1, 12],  // month
  [0, 7],   // day of week (0 and 7 = Sunday)
];

function isValidField(field: string, [min, max]: [number, number]): boolean {
  if (field === "*") return true;

  for (const part of field.split(",")) {
    const stepSplit = part.split("/");
    if (stepSplit.length > 2) return false;

    const range = stepSplit[0];
    const step = stepSplit[1];

    if (step !== undefined) {
      const s = Number(step);
      if (!Number.isInteger(s) || s < 1) return false;
    }

    if (range === "*") continue;

    const dashSplit = range.split("-");
    if (dashSplit.length > 2) return false;

    for (const val of dashSplit) {
      const n = Number(val);
      if (!Number.isInteger(n) || n < min || n > max) return false;
    }
  }

  return true;
}

export function isValidCronString(value: string): boolean {
  const fields = value.trim().split(/\s+/);
  if (fields.length !== 5) return false;
  return fields.every((field, i) => isValidField(field, CRON_FIELD_RANGES[i]));
}
